export default "__VITE_ASSET__BBhVRc0X__"